import { Text, View } from 'react-native'
import { useTranslation } from 'react-i18next'

import {
  formatJbpConfiguredFeeLabel,
  formatJbpRangeLabel,
  getAvailableJbpSettingsForVip,
  getJbpPaymentMethodLabel,
  JbpPaymentMethodSetting
} from '@/utils/jbp'

export function JbpVipConditions({ settings, vipLevel }: { settings: JbpPaymentMethodSetting[]; vipLevel: number }) {
  const { t } = useTranslation()
  const availableSettings = getAvailableJbpSettingsForVip(settings, vipLevel)

  return (
    <View className={'rounded-lg border border-border-10 bg-background-secondary px-3 py-2'}>
      <Text className={'text-sm font-medium text-text-primary'}>{t('fastPay:vipConditionsTitle', { level: vipLevel })}</Text>
      {availableSettings.length === 0 ? (
        <Text className={'mt-1 text-xs text-text-secondary'}>{t('fastPay:noVipPaymentMethods')}</Text>
      ) : (
        <View className={'mt-2 gap-y-2'}>
          {availableSettings.map((setting) => (
            <View key={`${setting.method}-${setting.vipLevel}`}>
              <View className={'flex-row items-center justify-between'}>
                <Text className={'text-xs font-medium text-text-primary'}>
                  {getJbpPaymentMethodLabel(setting.method)}
                </Text>
                <Text className={'text-xs text-primary'}>{t('fastPay:fee', { value: formatJbpConfiguredFeeLabel(setting) })}</Text>
              </View>
              <Text className={'mt-1 text-xs text-text-secondary'}>{t('fastPay:availableRange', { value: formatJbpRangeLabel(setting) })}</Text>
            </View>
          ))}
        </View>
      )}
    </View>
  )
}
